import assert from 'assert';


export const ThemeVariables = {
    TestPage: {
        MenuItemActiveColor: '#3275FA',
    },
    Common: {
        LinkColor: '#3275FA',
        ErrorColor: '#FA4B5A',
        WarningColor: '#FFBF00',
        TextPrimaryColor: '#303133',
        TextSecondaryColor: '#77787A',
        DisabledColor: '#B4B5B8',
        DarkColor: '#1C1D1F',
        InfoColor: '#9EA0A3',
        ButtonDisabledColor: '#C8C9CC',
        CheckboxColor: '#FFFFFF',
        NormalColor: '#5C6473',
    },
    Components: {
        ButtonNormalBackgroundColor: '#E8E9EB',
        MenuItemColor: '#1C1D1F',
        MenuItemHoverBackgroundColor: '#F2F3F5',
        ToastBackgroundColor: '#FFFFFF',
        ToastColor: '#171717',
        ToastBoxShadow: '0px 6px 20px 0px rgba(92,100,115,0.15)',
        TooltipBackgroundColor: '#FFFFFF',
        TooltipColor: '#1C1D1F',
        TooltipBoxShadow: '0 0 10px 0 rgba(146,156,174,0.40)',
        PaginationBorderColor: '#E0E0E0',
        PaginationActiveColor: '#FFFFFF',
        PaginationActiveBorderColor: '#3275FA',
        PaginationActiveBackgroundColor: '#3275FA',
    },
    Head: {
        TextColor: '#1C1D1F',
        SlashColor: '#E8E9EB',
        TabColor: '#9EBEFF',
        LogoColor: '#3275FA',
        CreateTextColor: '#74767A',
        IconButtonColor: '#4E4F52',
    },
    Tree: {
        NodeColor: '#1C1D1F',
        NodeSelectedColor: '#3377FF',
        NodeSelectedBgColor: 'rgba(51, 119, 255, 0.08)',
        NodeBgColor: 'transparent',
        NodeHighlightColor: '#3275FA',
        NodeHoverBgColor: 'rgba(92, 100, 115, 0.08)',
        NodeBorderColor: 'transparent',
        DragNodeBorderColor: '#3275FA',
    },
    FollowCard: {
        BorderColor: '#E8E9EB',
        ShadowColor: '#00000019',
        StarColor: '#FFBF00',
        GrayBackgroundColor: '#F2F2F2',
        SeparatorColor: '#E8E8E8',
        HighlightBackgroundColor: '#F2F3F5',
        titleHoverColor: '#3275FA',
    },
    Templates: {
        HighlightBackgroundColor: '#F2F3F5',
        SelectedBackgroundColor: '#EBF2FF',
    },
    Section: {
        GrayBackgroundColor: '#F2F2F2',
    },
    Team: {
        HeadNavIconColor: '#77787A',
        HeadNavTextColor: '#303133',
        HeadNavTextColorForCoverImage: '#FFF',
        HeadNavButtonBgColor: 'transparent',
        NoticeBackgroundColor: '#F7F8FA',
        CreateNoticeButton: '#DCDDE0',
        EditNoticeBackgroundColor: '#FFFFFF',
        ButtonShareTextColor: '#3275FA',
        DocName: '#1C1D1F',
        TabActive: '#000000',
        ButtonCancelBorder: '#C8C9CC',
        RemoveMemberDisabledColor: '#B8CBFF',
    },
    SettingSecurity: {
        FontColor: '#333333',
        CheckBoxColor: '#FFFFFF',
    },
    DynamicCard: {
        BackgroundColor: '#F7F8FA',
        BorderLeftColor: '#DCDDE0',
        BorderBottomColor: '#E8E9EB',
    },
    LikeCont: {
        GiveLikeColor: '#EBF2FF',
        CancelLikeColor: '#EEEEEE',
        GiveLikeTextColor: '#3275FA',
        CancleLikeTextColor: '#FFFFFF',
        GiveLikeIconColor: '#3275FA',
        CancleLikeIconColor: '#FFFFFF',
        ShowMoreBgColor: '#F2F3F5',
    },
    Sidebar: {
        BorderColor: '#F2F3F5',
        PageNodeColor: '#77787A',
        PageNodeSelectedColor: '#1C1D1F',
        NodeArrowColor: '#333333',
        ToolbarButtonColor: '#333333',
        ToolbarButtonHoverBackgroundColor: '#DEDFE0',
    },
    DragLine: {
        BackgroundColor: '#A6C6FF',
        BorderColor: '#ffffff',
        GripperColor: '#878D99',
        GripperHoverColor: '#11141A',
        GripperBackgroundColor: '#E8E9EB',
        GripperHoverBackgroundColor: '#C8C9CC',
    },
    Tag: {
        ExpiredColor: '#E8E9EB',
    },
    Template: {
        FontColor: '#4E4F52',
    },
    Approval: {
        TableTextColor: '#4E4F52',
    },
    Messages: {
        SeparatorColor: '#9EA5B2',
        IconColor: '#FFFFFF',
        AtBackgroundColor: '#3275FA',
        SystemBackgroundColor: '#3275FA',
        CommentBackgroundColor: '#18C460',
        DeleteBackgroundColor: ' #FF8D1A',
        PublishBackgroundColor: '#3275FA',
    },
    UploadLogoButton: {
        BorderColor: '#D4D5D5',
        HoverBorderColor: '#9EA0A3',
    },
    MoveDocument: {
        CheckedIconColor: '#1964FA',
    },
    Dialog: {
        HeadlineBkColor: '#FFF',
        HeadlineBorderColor: '#F2F3F5',
    },
    RecycleBin: {
        SelectedOperationBgColor: '#fff',
    },
};

export const initVariables = () => {
    const style = `
body {
    --wiki-link-color: ${ThemeVariables.Common.LinkColor};
    --wiki-error-color: ${ThemeVariables.Common.ErrorColor};
    --wiki-warning-color: ${ThemeVariables.Common.WarningColor};
    --wiki-text-primary-color: ${ThemeVariables.Common.TextPrimaryColor};
    --wiki-text-secondary-color: ${ThemeVariables.Common.TextSecondaryColor};
    --wiki-normal-color: ${ThemeVariables.Common.NormalColor};
    --wiki-checkbox-color: ${ThemeVariables.Common.CheckboxColor};
    --wiki-tooltip-color: ${ThemeVariables.Components.TooltipColor};
    --wiki-tooltip-background-color: ${ThemeVariables.Components.TooltipBackgroundColor};
    --wiki-tooltip-box-shadow: ${ThemeVariables.Components.TooltipBoxShadow};
    --wiki-toast-color: ${ThemeVariables.Components.ToastColor};
    --wiki-toast-background-color: ${ThemeVariables.Components.ToastBackgroundColor};
    --wiki-toast-box-shadow: ${ThemeVariables.Components.ToastBoxShadow};
    --wiki-menu-item-color: ${ThemeVariables.Components.MenuItemColor};
    --wiki-menu-item-hover-background-color: ${ThemeVariables.Components.MenuItemHoverBackgroundColor};
    --wiki-button-background-color: ${ThemeVariables.Components.ButtonNormalBackgroundColor};
}
`;
    const vStyle = window.document.createElement('style');
    const head = document.documentElement.querySelector('head');
    vStyle.id = 'wiki-variables';
    assert(head instanceof HTMLElement);
    vStyle.textContent = style;
    head.appendChild(vStyle);
};
